export const FETCH_MANUAL = 'manual.FETCH_MANUAL';
